import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import type { SetCookieOptions } from './useCookies';

interface Props {
  language: string;
  setCookie: (options: SetCookieOptions) => void;
}

const useSiteLanguage = ({ language, setCookie }: Props) => {
  const { i18n } = useTranslation();

  // This will likely trigger a flash the first time users visit the site,
  // But storage of the publication in the session should prevent it from happening again
  useEffect(() => {
    i18n.changeLanguage(language);
    setCookie({ name: 'language', value: language, days: 30 });
  }, [i18n, language]);
};

export default useSiteLanguage;
